/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'basic/no-folder-1218399': {
    width: 16,
    height: 16,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M21.71 20.29l-1.6-1.6-16.4-16.4a1 1 0 00-1.42 1.42l1.4 1.39A3 3 0 003 7v11a3 3 0 003 3h12a3 3 0 001.29-.3l1 1a1 1 0 001.42 0 1 1 0 000-1.41zM6 19a1 1 0 01-1-1V7a1 1 0 01.12-.46L17.59 19zm4.62-13a1 1 0 01.89.67l.54 1.64A1 1 0 0013 9h5a1 1 0 011 1v4.34a1 1 0 102 0V10a3 3 0 00-3-3h-4.28l-.32-1a3 3 0 00-2.68-2 1 1 0 00-.1 2z"/>'
  }
})
